module.exports = __webpack_public_path__ + "static/img/dq3.9d7b1b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/dq3.png
// module id = tPmK
// module chunks = 0